const branches = {
  branches: {
    pageHeader: 'Agences',
    addBranchOffice: '+ Ajouter une agence',
    name: 'Nom',
    city: 'Ville',
    state: 'État/Province',
    country: 'Pays',
    branches: 'Succursales',
    noBranchAvailable: '** Aucune succursale disponible **'
  }
};

export default branches;
